import { Fragment, type ReactNode } from 'react';

/**
 * Minimal Flux tokeniser. A full grammar would be a dependency; this covers the
 * constructs the generator actually emits, in a single pass, and falls back to plain
 * text for anything it does not recognise — so an unhighlighted token is never a
 * broken render.
 */
const TOKEN =
  /(\/\/[^\n]*)|("(?:[^"\\]|\\.)*")|\b(import|option|return|if|then|else|true|false|and|or|not)\b|\b(\d+(?:\.\d+)?(?:ms|[smhdw])?)\b|\b([A-Za-z_][A-Za-z0-9_]*)(?=\s*\()/g;

const CLASS_FOR_GROUP = ['c', 's', 'k', 'n', 'f'] as const;

export function highlightFlux(code: string): ReactNode[] {
  const nodes: ReactNode[] = [];
  let last = 0;
  let key = 0;
  TOKEN.lastIndex = 0;
  let match: RegExpExecArray | null;
  while ((match = TOKEN.exec(code)) !== null) {
    if (match.index > last) {
      nodes.push(<Fragment key={key++}>{code.slice(last, match.index)}</Fragment>);
    }
    const group = match.slice(1).findIndex((g) => g !== undefined);
    nodes.push(
      <span key={key++} className={CLASS_FOR_GROUP[group]}>
        {match[0]}
      </span>,
    );
    last = match.index + match[0].length;
  }
  if (last < code.length) nodes.push(<Fragment key={key++}>{code.slice(last)}</Fragment>);
  return nodes;
}
